export type ServiceError = {
  messages?: string[];
  code?: string;
};

export function getStatusCodeFromError(error: unknown): number | undefined {
  if (error === null || typeof error !== 'object') return undefined;

  if ('statusCode' in error && typeof error.statusCode === 'number') {
    return error.statusCode;
  }

  if (
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'status' in error.response &&
    typeof error.response.status === 'number'
  ) {
    return error.response.status;
  }

  return undefined;
}

function pickServiceErrorFields(error: unknown): ServiceError {
  if (error === null || typeof error !== 'object') return {};

  let messages: string[] | undefined;
  if ('messages' in error) {
    const m = error['messages'];
    if (
      Array.isArray(m) &&
      m.every((x): x is string => typeof x === 'string')
    ) {
      messages = m;
    }
  }

  let code: string | undefined;
  if ('code' in error && typeof error['code'] === 'string') {
    code = error['code'];
  }

  return { messages, code };
}

export function normalizeServiceError(error: unknown): ServiceError {
  const { messages, code } = pickServiceErrorFields(error);
  const statusFromHttp = getStatusCodeFromError(error);
  return {
    messages,
    code:
      code ??
      (statusFromHttp !== undefined ? String(statusFromHttp) : undefined),
  };
}
